import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Scroll active pill into view on mobile
    const activePill = this.element.querySelector(".nav-link.active, .list-group-item.active")
    if (activePill) {
      activePill.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" })
    }
  }
}
